import { CellContext } from '@tanstack/react-table';
import { SelectedTransportVariantDto } from '@/features/dashboard/participants/types/SelectedTransportVariantDto.ts';
import { formatPrice } from '@/utils/formatters.ts';
import { CellSecondary } from '@/components/table/_fieldDefinitions/_base/CellSecondary.tsx';
import { EmptyValue } from '@/components/ui/EmptyValue.tsx';

/**
 * The participants list endpoint returns `price.amount` as a nested object
 * `{ source, parsedValue }`, whereas the dedicated transport endpoint returns a
 * plain number. Resolve both shapes defensively before formatting.
 */
const resolveAmount = (amount: unknown): number | undefined => {
  if (typeof amount === 'number') return amount;
  if (amount && typeof amount === 'object' && 'parsedValue' in amount) {
    return (amount as { parsedValue: number }).parsedValue;
  }
  return undefined;
};

export const nestedTransportVariantFieldRender = <T,>(
  info: CellContext<T, unknown>,
) => {
  const value = info.getValue() as
    | SelectedTransportVariantDto
    | null
    | undefined;
  if (!value) return <EmptyValue />;

  const amount = resolveAmount(value.price?.amount);
  if (amount === undefined) return value.variantName;

  return (
    <>
      {value.variantName}{' '}
      <CellSecondary>
        ({formatPrice(amount, value.price.currency)})
      </CellSecondary>
    </>
  );
};
